// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportLink.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import AppGlobal from 'Izenda.AppGlobal';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';

!(function() {
  var React = require('react');
  var SubReportLink = require('./Izenda.SubReportLink');

  var ColumnDataObject = require('logic/models/Izenda.ColumnDataObject');
  var ProcessData = require('logic/Izenda.ReportPartGridProcessData');
  var PrintingUtils = require('share/utils/Izenda.PrintingUtils');
  var { get } = require('lodash/fp');

  var applySubReportLink = function(
    reportPart,
    displayValue,
    columnData,
    records,
    previewDataFieldsMapping,
    afterRenderCallBack,
    printingMode,
    renderListeners,
    id,
    getFilterInfoForSubReport
  ) {
    var fieldElement = get('element', columnData);
    var rawRecord = ProcessData.buildRawRecordFilterForPivotGrid(columnData, records);

    PrintingUtils.pushRenderListener(renderListeners, id);

    let title = displayValue;
    if(AppGlobal.isRenderHtmlInReportViewer()){
      displayValue = (<span dangerouslySetInnerHTML={{__html: displayValue}}></span>);
      title = ReportPartUtils.getTextContentFromHtmlString(title);
    }

    return (
      <SubReportLink
        reportPart={reportPart}
        fieldElement={fieldElement}
        afterRenderCallBack={afterRenderCallBack}
        printingMode={printingMode}
        finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, id)}
        getFilterInfoForSubReport={getFilterInfoForSubReport}
        rawRecord={rawRecord}
        linkTitleText={title}
      >
        {displayValue}
      </SubReportLink>
    );
  };

  var applySubReportCellLink = function(
    reportPart,
    displayValue,
    columnData,
    rowData,
    previewDataFieldsMapping,
    afterRenderCallBack,
    printingMode,
    renderListeners,
    id,
    getFilterInfoForSubReport
  ) {
    var data = [];

    if (columnData.type === ColumnDataObject.COLUMN_TYPE.ROW) {
      data = rowData.rowDataObjects[columnData.uniqueFieldNameAlias].rowDataObject.childsData;
    } else {
      data = rowData.currentRow.rowDataObject.childsData;
    }
    return applySubReportLink(
      reportPart,
      displayValue,
      columnData,
      data,
      previewDataFieldsMapping,
      afterRenderCallBack,
      printingMode,
      renderListeners,
      id,
      getFilterInfoForSubReport
    );
  };

  module.exports = {
    applySubReportLink: applySubReportLink,
    applySubReportCellLink: applySubReportCellLink
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.SubReportLinkUtils.js